import { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, ToggleControl, SelectControl } from '@wordpress/components';
import './editor.scss';
import Events from './components/Events';

export default function Edit({ attributes, setAttributes }) {
	const { showCalendar, showCards, showList, showSearch, showMap , eventsPerPage } = attributes;
	const [events, setEvents] = useState([]);

	useEffect(() => {
		const fetchEvents = async () => {
			try {
				const now = new Date();
				const currentYear = now.getFullYear();
				const currentMonth = String(now.getMonth() + 1).padStart(2, '0');
				const response = await fetch(`/wp-json/custom/v1/events?month=${currentMonth}&year=${currentYear}`);
				const eventsData = await response.json();
				setEvents(eventsData);
			} catch (error) {
				console.error('Error fetching events:', error);
			}
		};

		fetchEvents();
	}, []); // Run once when component mounts

	return (
		<div {...useBlockProps()}>
			<InspectorControls>
				<PanelBody title={__('Advanced Settings', 'my-block')} initialOpen={true}>
					<ToggleControl
						label={__('Show Calendar View', 'my-block')}
						checked={showCalendar}
						onChange={(value) => setAttributes({ showCalendar: value })}
					/>
					<ToggleControl
						label={__('Show Cards View', 'my-block')}
						checked={showCards}
						onChange={(value) => setAttributes({ showCards: value })}
					/>
					<ToggleControl
						label={__('Show List View', 'my-block')}
						checked={showList}
						onChange={(value) => setAttributes({ showList: value })}
					/>
					<ToggleControl
						label={__('Show Search', 'my-block')}
						checked={showSearch}
						onChange={(value) => setAttributes({ showSearch: value })}
					/>
					<ToggleControl
						label={__('Show Map', 'my-block')}
						checked={showMap}
						onChange={(value) => setAttributes({ showMap: value })}
					/>
					<SelectControl
						label={__('Events Per Page', 'my-block')}
						value={eventsPerPage}
						options={[
							{ label: '5', value: 5 },
							{ label: '10', value: 10 },
							{ label: '15', value: 15 },
							{ label: '20', value: 20 },
						]}
						onChange={(value) => setAttributes({ eventsPerPage: parseInt(value, 10) })}
					/>
				</PanelBody>
			</InspectorControls>

			<div className={'fsdpe-calendar-wrapper'}>

				<Events
					showCalendar={showCalendar}
					showCards={showCards}
					showList={showList}
					showSearch={showSearch}
					showMap={showMap}
					events={events}
					eventsPerPage={eventsPerPage}
				/>
			</div>
		</div>
	);
}
